import { request } from "../../../apis";
import { getCurrency } from "../../../plugins/utils";

const currentCurrency = getCurrency();

export const apiGetOpenedGameCategory = () =>
  request("get", `/${currentCurrency}/game/category/open`, {}, true);

export const apiGetOpenedGames = () =>
  request("get", `/${currentCurrency}/game/category/game/open`, {}, true);

export const apiGetProductReport = (params, categoryId, gameId) =>
  request(
    "get",
    `/${currentCurrency}/game/summary/winloss/${categoryId}/${gameId}`,
    params,
    true
  );

export const apiGetProductReportDetail = (params, categoryId, gameId) =>
  request(
    "get",
    `/${currentCurrency}/game/summary/winloss/${categoryId}/${gameId}/detail`,
    params,
    true
  );


export const apiGetProductOverview = () =>
  request("get", `/${currentCurrency}/agent/dashboard/game`, {}, true);
